'use strict';


/* ========================================================
 * 		jQuery
 *
 * If you need jQuery in a JS file add this to the top of that file:
 * 		var $ = require('jquery');
 * If some JS code MUST have jQuery globally accessible then
 * add the following line inside this file (index.js).
 * 		var $ = window.jQuery = require('jquery');
 ========================================================= */
var $ = window.jQuery = require('jquery');

/* ========================================================
 * 		Requires
 ========================================================= */

// Polyfills
require('./polyfills/requestAnimationFrame.js');

// Lib
require("@plaudit/jsf-ajax-adapters/dist/jQuery").default.init();
var Analytics = require('@plaudit/analytics').Analytics;
require('./lib/third-party/fontawesome-all.js');

// Components
var Forms = require('./lib/Forms.js');
var MobileMenu = require('./site/MobileMenu.js');
var MastheadSlideshow = require('./site/MastheadSlideshow.js');
var Slideshow = require('./site/Slideshow.js');

/* ========================================================
 * 		Component Setup
 ========================================================= */
Forms.init();
MobileMenu.init();
MastheadSlideshow.init();
Slideshow.init();

// Initialize Google Analytics
new Analytics();
